import * as React from 'react';
import { AccordionItem, AccordionHeader, AccordionTitle, AccordionContent } from '@telia-front/accordion';
import { Grid, GridColumn } from '@telia-front/grid';
import Tooltip from '@telia-front/tooltip';
import TooltipToggle from '@telia-front/tooltip-toggle';
import { FilterContext } from '../filter/filter-context';
const FilterSection = (props) => {
    const { id, title, children, tooltip, defaultIsOpen = false, isOpen: propOpen, onToggle, purpose } = props;
    const [openState, setOpenState] = React.useState(defaultIsOpen);
    const context = React.useContext(FilterContext);
    const sectionPurpose = purpose ? purpose : context.purpose;
    const isEmployee = sectionPurpose === 'employee';
    const isOpen = propOpen !== undefined ? propOpen : openState;
    const handleToggle = (nextOpen) => {
        if (propOpen === undefined) {
            setOpenState(nextOpen);
        }
        if (onToggle) {
            onToggle(nextOpen);
        }
    };
    const renderTooltip = (tooltip, id) => (React.createElement(React.Fragment, null,
        React.createElement(TooltipToggle, { id: id + '-tooltip-toggle', icon: true, color: isEmployee ? 'employee' : undefined }, tooltip.label),
        React.createElement(Tooltip, { referenceElement: '#' + id + '-tooltip-toggle' }, tooltip.content)));
    return (React.createElement(AccordionItem, { id: id, type: isEmployee ? 'employee' : undefined, background: "transparent", isOpen: isOpen, onToggle: handleToggle },
        React.createElement(AccordionHeader, null,
            React.createElement(Grid, { gutter: "xsmall" },
                React.createElement(GridColumn, { width: ['min'] },
                    React.createElement(AccordionTitle, null, title)),
                React.createElement(GridColumn, { width: ['min'] }, tooltip && renderTooltip(tooltip, id)))),
        React.createElement(AccordionContent, null, children)));
};
export default FilterSection;
